// extracted by mini-css-extract-plugin
module.exports = {"container":"Supplement_container__YPGvL","header":"Supplement_header__HS4CE","closeButton":"Supplement_closeButton__bV8Rp","buttonContainer":"Supplement_buttonContainer__gpkcz"};